

























































































import {
  computed,
  defineComponent,
  getCurrentInstance,
  onBeforeUnmount,
  PropType,
  ref,
  watch,
} from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { lockBodyScroll } from "@scrile/tools/dist/lib/Scrollhelpers";
import { isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getMediaDuration } from "@/lib/time";
import { UploadVaultFile } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";
import ImageZoomer from "@/components/ImageZoomer";
import VaultFileCaption from "./VaultFileCaption.vue";

export default defineComponent({
  name: "VaultFileItemWithPreview",
  components: { VaultFileCaption, BaseImage, BaseIcon, ImageZoomer },
  props: {
    isLoading: { type: Boolean, default: false },
    thumbnails: { type: Boolean, default: false },
    fileClasses: { type: Array as () => Record<string, string>[] },
    file: { type: Object as () => UploadVaultFile, required: true },
    isFileSent: { type: Boolean, default: false },
    isFilePurchased: { type: Boolean, default: false },
    showCaption: { type: Boolean, default: false },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, default: () => [] },
  },
  setup(props, { root }) {
    const vm = getCurrentInstance();

    const isVideoStarted = ref(false);
    const videoElement = ref<HTMLVideoElement>();
    const isVideo = computed<boolean>(() => isVideoFile(props.file));
    const videoSrc = computed<string>(() =>
      isVideo.value ? MediaFilesController.getVideoUrl(props.file.urlPart) : ""
    );
    const onPlayVideo = () => {
      if (videoElement.value) {
        isVideoStarted.value = true;
        videoElement.value.play();
      }
    };

    const loaded = ref(false);
    const domRect = ref<DOMRect>();
    const onLoad = async () => {
      if (loaded.value) {
        return;
      }
      loaded.value = true;
      await vm?.$nextTick();
      if (root) {
        domRect.value = root.$el.getBoundingClientRect();
      }
    };

    const isFullScreen = ref(false);
    const onCloseFullScreen = () => {
      isFullScreen.value = false;
      isVideoStarted.value = false;
    };
    const vaultFileSrc = computed<string>(() => {
      if (!props.file.urlPart) return "";
      return isVideo.value
        ? MediaFilesController.getVideoThumbnail(props.file.urlPart, isFullScreen.value ? "1080p" : "360p")
        : MediaFilesController.getImageThumbnail(props.file.urlPart, isFullScreen.value ? "1080p" : "360p");
    });

    const icon = computed(() => (isVideo.value ? "sci-video" : "sci-image"));
    const isZoomable = computed<boolean>(() => !isVideo.value && !isVideoStarted.value);
    const getVaultDuration = computed<string>(() => getMediaDuration(Number(props.file.metadata.duration)));

    const isBottomLeftIcon = computed(() => !props.thumbnails && (props.isFileSent || props.isFilePurchased));
    const showWarningIcon = computed(() => props.showCaption && props.file.pricePackageId === null);

    watch(isFullScreen, mode => {
      lockBodyScroll(mode);
    });

    onBeforeUnmount(() => {
      if (isFullScreen.value) lockBodyScroll(false);
    });

    return {
      icon,
      isVideo,
      videoSrc,
      isZoomable,
      videoElement,
      vaultFileSrc,
      isFullScreen,
      isVideoStarted,
      getVaultDuration,
      isBottomLeftIcon,
      onLoad,
      onPlayVideo,
      onCloseFullScreen,
      showWarningIcon,
    };
  },
});
